<template>
    <b-row>
        <b-col cols="12" class="flex-grow-0 flex-shrink-1 text-nowrap py-1">
            仮登録: {{ model.created_at | baseDatetimeFormatter }}<br>
            本登録: {{ model.sent_at | baseDatetimeFormatter }}<br>
            入金:
            <template v-if="model.payment_provider === 'BANK'">
                {{ model.payment_settled_at | baseDateFormatter }}
            </template>
            <template v-else>
                {{ model.payment_settled_at | baseDatetimeFormatter }}
            </template>
            <br>
            完了: {{ model.completed_at | baseDatetimeFormatter }}<br>
            取消: {{ model.canceled_at | baseDatetimeFormatter }}<br>
        </b-col>
    </b-row>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    components: {
    },
    props: {
        model: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
    },
    data() {
        return {}
    },
    computed: {
        ...mapGetters([
            'auth_id',
            'auth_level',
            'trans',
        ])
    },
    async mounted() {},
    methods: {
    },
}
</script>

<style lang="scss" scoped></style>

